module.exports = ".page-content {\r\n    margin-bottom: -100px;\r\n}\r\n\r\n.footer-gap {\r\n    height: 100px;\r\n}\r\n\r\n/* Loading screen */\r\n\r\n#overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 1010;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n#loading-box {\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 50%;\r\n    height: 200px;\r\n    width: 400px;\r\n    margin-left: -200px;\r\n    margin-top: -100px;\r\n    z-index: 1011;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main